import fetch, { postForm } from '@/utils/fetch';
import { getToken } from '@/utils';

export const updateItemChecked = async params => {
  return postForm({
    url: '/windfarm/project/updateItemChecked',
    data: {
      apiKey: getToken(),
      ...params
    },
    showError: true
  });
};

export const getTowerByPlanId = async planId => {
  return fetch({
    url: '/windfarm/station/getRecommendTowerList',
    method: 'get',
    params: {
      apiKey: getToken(),
      planId
    },
    showError: true
  });
};

export const getTurbineList = async planId => {
  return fetch({
    url: '/windfarm/station/getEnergyTurbineList',
    method: 'get',
    params: {
      apiKey: getToken(),
      planId
    },
    showError: true
  });
};

export const createStation = async params => {
  return postForm({
    url: '/windfarm/project/createStation',
    data: {
      apiKey: getToken(),
      ...params
    },
    showLoading: true,
    showSuccess: '创建风场范围成功',
    showError: true
  });
};

export const queryProjectInfo = async id => {
  return fetch({
    url: '/windfarm/project/getProjectById',
    method: 'get',
    params: {
      apiKey: getToken(),
      projectId: id
    },
    showError: true
  }).then(res => {
    const { data } = res;
    return data?.projectInfo || {};
  });
};

// 获取项目下的风资源列表
export const getUserItemList = async function(params) {
  return fetch({
    url: '/windfarm/project/getUserItemList',
    method: 'get',
    params: {
      apiKey: getToken(),
      ...params
    },
    showError: true
  });
};
// 获取方案列表
export const refreshWindfarmPlanList = async function(params) {
  return fetch({
    url: '/windfarm/station/refreshWindfarmPlanList',
    method: 'get',
    params: {
      apiKey: getToken(),
      ...params
    },
    showError: true
  });
};
export const createWindfarmPlan = async function(params) {
  return postForm({
    url: '/windfarm/station/createWindfarmPlan',
    data: {
      apiKey: getToken(),
      ...params
    },
    showError: true
  });
};
//修改方案名称
export const updatePlanName = async function(params) {
  return postForm({
    url: '/windfarm/station/updatePlanName',
    data: {
      apiKey: getToken(),
      ...params
    },
    showError: true,
    showSuccess: true
  });
};
// 删除方案
export const deleteWindfarmPlan = async function(params) {
  return postForm({
    url: '/windfarm/station/deleteWindfarmPlan',
    data: {
      apiKey: getToken(),
      ...params
    },
    showError: true,
    showSuccess: true
  });
};

//风资源名称
export const updateItemName = async function(params) {
  return postForm({
    url: '/windfarm/project/updateItemName',
    data: {
      apiKey: getToken(),
      ...params
    },
    showError: true
  });
};

// 删除资源
export const deleteWindItem = async function(params) {
  return postForm({
    url: '/windfarm/project/deleteItem',
    data: {
      apiKey: getToken(),
      ...params
    },
    showError: true
  });
};
// 获取敏感因素列表
export const getWindfarmExclusive = async function(params) {
  return fetch({
    url: '/windfarm/project/getWindfarmExclusive',
    params: {
      apiKey: getToken(),
      ...params
    },
    showError: true
  });
};

// 删除敏感因素
export const deleteWindfarmExclusive = async function(params) {
  return postForm({
    url: '/windfarm/project/deleteWindfarmExclusive',
    data: {
      apiKey: getToken(),
      ...params
    },
    showError: true
  });
};
// 修改敏感因素名称
export const updateExclusiveName = async function(params) {
  return postForm({
    url: '/windfarm/project/updateExclusiveName',
    data: {
      apiKey: getToken(),
      ...params
    },
    showError: true
  });
};

// 新建敏感因素
export const saveWindfarmExclusive = async function(params) {
  return postForm({
    url: '/windfarm/project/saveWindfarmExclusive',
    data: {
      apiKey: getToken(),
      ...params
    },
    showError: true
  });
};

export const getEconomicResultList = async function(params) {
  return postForm({
    url: '/windfarm/stationReport/getEconomicResultList',
    method: 'post',
    data: {
      apiKey: getToken(),
      ...params
    },
    showError: true
  });
};

//上传敏感因素
export const uploadExclusiveFile = async function(params) {
  return postForm({
    url: '/windfarm/project/uploadExclusiveFileByFileId',
    data: {
      apiKey: getToken(),
      ...params
    },
    showError: true,
    showLoading: true,
    showSuccess: true
  });
};

//上传机位文件
export const uploadLayoutFile = async function(params) {
  return postForm({
    url: '/windfarm/station/uploadPlanTurbineListByFileId',
    data: {
      apiKey: getToken(),
      ...params
    },
    showError: true,
    showLoading: true,
    showSuccess: true
  });
};

// 获取所有风机型号及对应的轮毂高度
export const getTurbineTypeList = async function(params) {
  return fetch({
    url: '/windfarm/station/getTurbineTypeList',
    method: 'get',
    params: {
      apiKey: getToken(),
      ...params
    },
    showError: true
  });
};


// 修改风机
export const updateFengji = async function(params) {
  return postForm({
    url: '/windfarm/station/updateTurbine',
    data: {
      apiKey: getToken(),
      ...params
    },
    showError: true,
    showSuccess: true
  });
};


// 修改风机
export const updateTower = async function(params) {
  return postForm({
    url: '/windfarm/station/updateRecommendTower',
    data: {
      apiKey: getToken(),
      ...params
    },
    showError: true,
    showSuccess: true
  });
};

//上传风场边界
export const uploadBoudaryFile = async function(params) {
  return postForm({
    url: '/windfarm/station/uploadWindFarmBoundaryByFileId',
    data: {
      apiKey: getToken(),
      ...params
    },
    showError: true,
    showLoading: true,
    showSuccess: true
  });
};

// 设置默认方案
export const setDefaultPlan = async function(params) {
  return fetch({
    url: '/windfarm/stationKY/setDefaultPlan',
    method: 'get',
    params: {
      apiKey: getToken(),
      ...params
    },
    showError: true,
    showSuccess: true
  });
};

// 设置工程的默认要素
export const setTypicalItem = async function(params) {
  return fetch({
    url: '/windfarm/project/updateItemTypical',
    method: 'POST',
    params: {
      apiKey: getToken(),
      ...params
    },
    showError: true,
    showSuccess: true
  });
};

// 获取敏感因素类型列表
export const getExclusiveTypeList = async function() {
  return fetch({
    url: '/windfarm/station/getExclusiveTypeList',
    method: 'get',
    params: {
      apiKey: getToken()
    },
    showError: true
  });
};
